import { DtoUsuario } from "./DtoUsuario";

export class DtoBitacora {
    Action: string = '';
    Fecha: Date = new Date();
    Usuario: DtoUsuario = new DtoUsuario();
    Description: string = '';
}